/**
 * You can test run builds with `http-server ./dist/Perito -p 4200 -c-1 --proxy http://localhost:4200/?`.
 * For that you will need to install `http-server` globally on your machine if you haven't done it already.
 */

// main.ts

import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';


import {EnvironmentMode} from 'src/shared/environment-types';
import {environment} from './environments/environment';

if (environment.mode === EnvironmentMode.PRODUCTION || environment.mode === EnvironmentMode.STAGING) {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(
	err => console.error(err)
);
